import { api } from '@/lib/api';
import type { CreateServicePackageInput, ServicePackage, UpdateServicePackageInput, PackageModule } from './types';

const VENDOR_BASE = '/vendor/service-packages';

export async function fetch_service_packages(): Promise<ServicePackage[]> {
  const res = await api.get<ServicePackage[]>(VENDOR_BASE);
  return res.data;
}

export async function create_service_package(input: CreateServicePackageInput): Promise<ServicePackage> {
  const res = await api.post<ServicePackage>(VENDOR_BASE, input);
  return res.data;
}

export async function update_service_package(id: string, input: UpdateServicePackageInput): Promise<ServicePackage> {
  const res = await api.patch<ServicePackage>(`${VENDOR_BASE}/${id}`, input);
  return res.data;
}

export async function delete_service_package(id: string): Promise<void> {
  await api.delete(`${VENDOR_BASE}/${id}`);
}

/** Pet-owner view: a walker's / trainer's active packages. */
export async function fetch_public_service_packages(vendor_id: string, module_type?: PackageModule): Promise<ServicePackage[]> {
  const res = await api.get<ServicePackage[]>(`/user/vendors/${vendor_id}/service-packages`, {
    params: module_type ? { module_type } : undefined,
  });
  return res.data;
}
